import { Options, Vue } from 'vue-class-component'
import DashboardGrid from '@/components/Frontend/DashboardGrid/index.vue'
import { Posts } from '@/services/PostsDataService'
import fallbackImg from '@/assets/img/img_fallback_dark_.png'
import { mediaBaseURL } from '@/components/Utility/Base'

@Options({
  components: {
    DashboardGrid
  }
})
export default class CustomGrid extends Vue {
  readonly mediaBaseUrl: string = mediaBaseURL

  public items: any[] = []
  currentIndex = 0
  autoSlideInterval: any = null

  get slideGroups () {
    // console.log(this.items, '>>>>>>>>>>>>>>>>>>')
    const groups = []
    for (let i = 0; i < this.items.length; i += 4) {
      groups.push(this.items.slice(i, i + 4))
    }
    console.log(groups[0])
    return groups
  }

  nextSlide (): void {
    if (this.currentIndex + 1 < this.slideGroups.length) {
      this.currentIndex++
    } else {
      this.currentIndex = 0
    }
  }

  prevSlide (): void {
    if (this.currentIndex - 1 >= 0) {
      this.currentIndex--
    } else {
      this.currentIndex = this.slideGroups.length - 1
    }
  }

  openItem (item: any): void {
    this.$router.push({
      name: 'Indlaeg_type',
      params: { indlaeg_type: item?.indlaeg_kategori_id?.indlaeg_kategori_titel, indlaegSlug: item.indlaeg_slug }
    })
  }

  formatDate (isoDate: string): string {
    const date = new Date(isoDate)
    const options = { month: 'long', day: 'numeric', year: 'numeric' }
    return date.toLocaleDateString('en-US', options)
  }

  extractImgUrl (content: any) {
    const html = content?.indlaeg_versionerings_id?.[content?.indlaeg_versionerings_id.length - 1]?.indlaeg_versionering_indhold ?? ''
    const urls = new Set()

    const combinedRegex = /<img[^>]+src=["']([^"']+\.(?:jpg|jpeg|png|gif|webp|svg))["']|https?:\/\/[^\s"'<>]+?\.(?:jpg|jpeg|png|gif|webp|svg)/gi
    let match

    while ((match = combinedRegex.exec(html)) !== null) {
      urls.add(match[1] || match[0])
    }
    const res = Array.from(urls)[0]
    return res
  }

  public async getData (): Promise<void> {
    try {
      const response = await Posts.PostsDataService.getPopulatedData()
      if (response?.data) {
        this.items = response.data
      }
    } catch (error) {
      console.error('Failed to fetch indlaegs data', error)
    }
  }

  startAutoSlide () {
    this.autoSlideInterval = setInterval(() => {
      this.nextSlide()
    }, 5000)
  }

  goToCategories (categoryType:any, e:any) {
    e.stopPropagation()
    this.$router.push({
      name: 'category',
      params: { categoryType: categoryType }
    })
  }

  stopAutoSlide () {
    clearInterval(this.autoSlideInterval)
  }

  async mounted (): Promise<void> {
    await this.getData()
    this.startAutoSlide()
  }

  beforeUnmount (): void {
    this.stopAutoSlide()
  }
}
